import { withI18n } from 'react-i18next';
import { connect } from 'react-redux';
import SamsungOrderInvoiceResultTable from './SamsungOrderInvoiceResultTable';
import { samsungOrderActions } from 'src/store/modules/samsungOrderInvoice';
import actions from 'src/store/modules/samsungOrderInvoice/actions';
import {
  samsungOrderInvoicesListSel,
  pageInformationSel
} from 'src/store/modules/samsungOrderInvoice/selectors';
import { userDataSel } from 'src/store/modules/user/selectors';
import { IInitialState } from 'src/store/initialState';

const mapStateToProps = (state: IInitialState) => ({
  samsungOrderInvoiceResults: samsungOrderInvoicesListSel(state),
  pageInformation: pageInformationSel(state),
  userData: userDataSel(state)
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(SamsungOrderInvoiceResultTable));
